const dictionary = {
  legal: 'Legal',

  // EN
  'terms-of-use': 'Terms of Use',
  'payments-policy': 'Payment Policy',
  'responsible-use-policy': 'Responsible Use Policy',
  'data-privacy-policy': 'Privacy Policy',
  'cookies-policy': 'Cookie Policy',
  'purchase-terms': 'Terms of Purchase',
  glossary: 'Glossary',
  'cybersecurity-policy': 'Cybersecurity Policy',

  // ES
  'terminos-de-uso': 'Términos de Uso',
  'politica-de-pago': 'Política de Pagos',
  'politicas-de-uso': 'Política de Uso Responsable',
  'privacidad-de-datos': 'Política de Privacidad',
  'politica-de-cookies': 'Política de Cookies',
  'plazo-de-compra': 'Términos de compra',
  glosario: 'Glosario',
  'politica-de-seguridad': 'Política de Seguridad de la Información',

  // PT-BR
  'termos-de-uso': 'Termos de uso',
  'privacidade-de-dados': 'Política de Dados',
  'politicas-de-uso': 'Política de Uso',
  'politicas-de-pagamento': 'Política de Pagamentos',
  'politica-de-cookies': 'Política de Cookies',
  'termos-de-compra': 'Termos de Compra',
  glossario: 'Glossário',
  'politica-de-seguranca-cibernetica': 'Política de Segurança Cibernética e da Informação',
  'whatsapp-business': 'Whatsapp Business',

  // FR
  'conditions-generales-dutilisation': 'Conditions d’Utilisation',
  'politique-de-paiements': 'Politique de Paiements',
  'politique-generale-dutilisation-responsable': "Politique d'utilisation Responsable",
  'politique-de-confidentialite': 'Politique de Confidentialité',
  'politique-de-cookies': 'Politique de cookies',
  'conditions-generales-dachat': 'Conditions d’Achat',
  glossaire: 'Glossaire',
  'politique-de-securite': "Politique de sécurité de l'information",

  // IT
  'termini-generali-di-utilizzo': 'Termini Generali di Utilizzo',
  'politica-di-pagamento': 'Politica Generale di Pagamento',
  'politica-generale-di-utilizzo-responsabile': 'Politica Generale di Utilizzo Responsabile',
  'termini-generali-di-acquisto': 'Termini Generali di Acquisto',
  glossario: 'Glossario',

  // DE
  'allgemeine-nutzungsbedingungen': 'Allgemeine Nutzungsbedingungen',
  'allgemeine-zahlungspolitik': 'Allgemeine Zahlungspolitik',
  'allgemeine-politik-der-verantwortungsbewussten-nutzung': 'Allgemeine Politik der Verantwortungsbewussten Nutzung',
  'allgemeine-kaufbedingungen': 'Allgemeine Kaufbedingungen',
  glossar: 'Glossar',
}

export default dictionary
